import consumer from "./consumer"
import confetti from "canvas-confetti"

function triggerFireworks(wrapper) {
  if (!wrapper) return

  const rect = wrapper.getBoundingClientRect()

  const x = (rect.left + rect.width / 2) / window.innerWidth
  const y = (rect.top + rect.height / 2) / window.innerHeight

  confetti({
    particleCount: 25,
    spread: 30,
    startVelocity: 15,
    gravity: 1.2,
    ticks: 250,
    origin: { x, y }
  })
}


function triggerFullPageCelebration() {
  const duration = 2000
  const end = Date.now() + duration

  ;(function frame() {
    confetti({
      particleCount: 7,
      angle: 90,
      spread: 120,
      startVelocity: 45,
      gravity: 1.2,
      ticks: 300,
      origin: {
        x: Math.random(),
        y: Math.random() * 0.4
      }
    })

    if (Date.now() < end) {
      requestAnimationFrame(frame)
    }
  })()
}

consumer.subscriptions.create("TaskUpdatesChannel", {
  connected() {
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    var taskId = data.task
    var taskListId = data.task_list
    var blockId = data.block_id
    
   
      if (window.activeEditingManager && blockId && window.activeEditingManager.isBlockBeingEdited(blockId)) {
        return;
      }
    
    
    var celebration = Boolean(data?.celebration === true);
    var allTasksCompleted = Boolean(data?.all_tasks_completed === true);
    
    
    if (data.action == "create") {
      var taskListWrapper = document.querySelector(`.process#task_list_${taskListId}`);
      if (taskListWrapper && data.html_value) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data.html_value;
        var updatedTaskList = tmp.querySelector(`.process#task_list_${taskListId}`) || tmp.querySelector('ol.steps');
        
        if (updatedTaskList) {
          var currentTaskListOl = taskListWrapper.querySelector('ol.steps');
          if (currentTaskListOl) {
            currentTaskListOl.innerHTML = updatedTaskList.innerHTML;
          }
        }
        
        
        if (data.task_list_description) {
          var taskListDescriptionContainer = document.querySelector('.process-description');
          if (taskListDescriptionContainer) {
            var descriptionTmp = document.createElement('div');
            descriptionTmp.innerHTML = data.task_list_description;
            var newContent = descriptionTmp.querySelector('.process-description') || descriptionTmp.firstElementChild;
            if (newContent) {
              taskListDescriptionContainer.replaceWith(newContent);
            }
          }
        }
      }
      return;
    }
    
    
    if (data.action == "destroy_task_list") {
      
      var currentPath = window.location.pathname;
      var taskListId = data.task_list;
      var projectId = data.project_id;
      var accountId = data.account_id;
      
      
      if (currentPath && currentPath.includes(`/task_lists/${taskListId}`)) {
        
        if (accountId && projectId) {
          window.location.href = `/${accountId}/projects/${projectId}/tasks`;
        }
      }
      return;
    }
    
    
    if (data.action == "destroy") {
      var taskListWrapper = document.querySelector(`.process#task_list_${taskListId}`);
      if (taskListWrapper) {
        
        var deletedTask = taskListWrapper.querySelector(`ol.steps li#task_${taskId}`);
        if (deletedTask && deletedTask.parentNode) {
          deletedTask.parentNode.removeChild(deletedTask);
        }
        
        
        if (data.html_value) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data.html_value;
          var updatedTaskList = tmp.querySelector(`.process#task_list_${taskListId}`) || tmp.querySelector('ol.steps');
          
          if (updatedTaskList) {
            var currentTaskListOl = taskListWrapper.querySelector('ol.steps');
            if (currentTaskListOl) {
              
              var processEnd = taskListWrapper.querySelector('.process-end');
              var updatedProcessEnd = updatedTaskList.querySelector('.process-end') || tmp.querySelector('.process-end');
              if (updatedProcessEnd) {
                if (processEnd) {
                  processEnd.outerHTML = updatedProcessEnd.outerHTML;
                } else {
                  currentTaskListOl.insertAdjacentHTML('afterend', updatedProcessEnd.outerHTML);
                }
              } else if (processEnd) {
                processEnd.remove();
              }
            }
          }
        }
        
        
        if (data.task_list_description) {
          var taskListDescriptionContainer = document.querySelector('.process-description');
          if (taskListDescriptionContainer) {
            var descriptionTmp = document.createElement('div');
            descriptionTmp.innerHTML = data.task_list_description;
            var newContent = descriptionTmp.querySelector('.process-description') || descriptionTmp.firstElementChild;
            if (newContent) {
              taskListDescriptionContainer.replaceWith(newContent);
            }
          }
        }
      }
      return;
    }
    
    
    var container = document.querySelector(`[data-task--tabs-task-id="${taskId}"]`);
    if (!container) {
      
      var taskListWrapper = document.querySelector(`.process#task_list_${taskListId}`);
      if (taskListWrapper) {
        container = taskListWrapper.querySelector(`li#task_${taskId}`);
      }
    }
    
    var tmp = document.createElement('div');
    tmp.innerHTML = data.html_value;
    var updatedContent = tmp.querySelector(`[data-task--tabs-task-id="${taskId}"]`) || tmp.querySelector(`li#task_${taskId}`);
    
    if (data.action == "complete") {
      if (updatedContent && container) {
        updatedContent.className = container.className
        updatedContent.classList.remove('incomplete')
        updatedContent.classList.add('complete')
        container.replaceWith(updatedContent)
        if ( celebration ) {
          requestAnimationFrame(() => {
            if (allTasksCompleted) {
              triggerFullPageCelebration()
            }
          })
        }
      }
    }
    
    if (data.action == "un_complete") {
      if (updatedContent && container) {
        updatedContent.className = container.className
        updatedContent.classList.remove('complete')
        updatedContent.classList.add('incomplete')
        container.replaceWith(updatedContent)
      }
    }

    if (data.action == "update_content"){
     
      if (updatedContent && container && !blockId) {
       
        var oldTabPanel = container.querySelector(`[data-panelid="${taskId}_content"]`);
        var newTabPanel = updatedContent.querySelector(`[data-panelid="${taskId}_content"]`);
        if (oldTabPanel && newTabPanel) {
          oldTabPanel.innerHTML = newTabPanel.innerHTML
        }
      } else if (blockId) {
      }
      
      
      if (data.task_list_html && !blockId) {
        var taskListWrapper = document.querySelector(`.process#task_list_${taskListId}`);
        if (taskListWrapper) {
          var listTmp = document.createElement('div');
          listTmp.innerHTML = data.task_list_html;
          var updatedTaskList = listTmp.querySelector(`.process#task_list_${taskListId}`) || listTmp.querySelector('ol.steps');
          
          if (updatedTaskList) {
            var currentTaskListOl = taskListWrapper.querySelector('ol.steps');
            if (currentTaskListOl) {
              
              var taskInList = currentTaskListOl.querySelector(`li#task_${taskId}`);
              var updatedTaskInList = updatedTaskList.querySelector(`li#task_${taskId}`);
              if (taskInList && updatedTaskInList) {
                
                var wasExpanded = taskInList.classList.contains('expanded');
                taskInList.outerHTML = updatedTaskInList.outerHTML;
                
                if (wasExpanded) {
                  var newTaskInList = currentTaskListOl.querySelector(`li#task_${taskId}`);
                  if (newTaskInList) {
                    newTaskInList.classList.add('expanded');
                  }
                }
              }
            }
          }
        }
      } else if (blockId && data.task_list_html) {
      }
      
      
      if (data.task_list_description) {
        var taskListDescriptionContainer = document.querySelector('.process-description');
        if (taskListDescriptionContainer) {
          var descriptionTmp = document.createElement('div');
          descriptionTmp.innerHTML = data.task_list_description;
          var newContent = descriptionTmp.querySelector('.process-description') || descriptionTmp.firstElementChild;
          if (newContent) {
            taskListDescriptionContainer.replaceWith(newContent);
          }
        }
      }
      
      if (!updatedContent || !container) {
        console.warn('Could not find element for taskId', taskId);
      }
    }
    
    
    
    if (data.action == "update_markdown") {
      
      if (data.task_list_html && data.task_list) {
        var taskListWrapper = document.querySelector(`.process#task_list_${data.task_list}`);
        if (taskListWrapper) {
          var listTmp = document.createElement('div');
          listTmp.innerHTML = data.task_list_html;
          var updatedTaskList = listTmp.querySelector(`.process#task_list_${data.task_list}`) || listTmp.querySelector('ol.steps');
          
          if (updatedTaskList) {
            var currentTaskListOl = taskListWrapper.querySelector('ol.steps');
            if (currentTaskListOl) {
              currentTaskListOl.innerHTML = updatedTaskList.innerHTML;
            }
          }
        }
        
        
        if (data.task_list_description) {
          var taskListDescriptionContainer = document.querySelector('.process-description');
          if (taskListDescriptionContainer) {
            var descriptionTmp = document.createElement('div');
            descriptionTmp.innerHTML = data.task_list_description;
            var newContent = descriptionTmp.querySelector('.process-description') || descriptionTmp.firstElementChild;
            if (newContent) {
              taskListDescriptionContainer.replaceWith(newContent);
            }
          }
        }
      }
      
      
      if (data.html_value && data.task && data.task_list) {
        var container = document.querySelector(`[data-task--tabs-task-id="${data.task}"]`);
        if (!container) {
          var taskListWrapper = document.querySelector(`.process#task_list_${data.task_list}`);
          if (taskListWrapper) {
            container = taskListWrapper.querySelector(`li#task_${data.task}`);
          }
        }
        
        if (container) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data.html_value;
          var updatedContent = tmp.querySelector(`[data-task--tabs-task-id="${data.task}"]`) || tmp.querySelector(`li#task_${data.task}`);
          
          if (updatedContent && container) {
            var oldTabPanel = container.querySelector(`[data-panelid="${data.task}_content"]`);
            var newTabPanel = updatedContent.querySelector(`[data-panelid="${data.task}_content"]`);
            if (oldTabPanel && newTabPanel) {
              oldTabPanel.innerHTML = newTabPanel.innerHTML;
            }
          }
        }
        
        
        if (data.task_list_html) {
          var taskListWrapper = document.querySelector(`.process#task_list_${data.task_list}`);
          if (taskListWrapper) {
            var listTmp = document.createElement('div');
            listTmp.innerHTML = data.task_list_html;
            var updatedTaskList = listTmp.querySelector(`.process#task_list_${data.task_list}`) || listTmp.querySelector('ol.steps');
            
            if (updatedTaskList) {
              var currentTaskListOl = taskListWrapper.querySelector('ol.steps');
              if (currentTaskListOl) {
                var taskInList = currentTaskListOl.querySelector(`li#task_${data.task}`);
                var updatedTaskInList = updatedTaskList.querySelector(`li#task_${data.task}`);
                if (taskInList && updatedTaskInList) {
                  var wasExpanded = taskInList.classList.contains('expanded');
                  taskInList.outerHTML = updatedTaskInList.outerHTML;
                  
                  if (wasExpanded) {
                    var newTaskInList = currentTaskListOl.querySelector(`li#task_${data.task}`);
                    if (newTaskInList) {
                      newTaskInList.classList.add('expanded');
                    }
                  }
                }
              }
            }
          }
        }
      }
      
      return
    }
    
    if (data.action == "update_description") {
      var taskListDescriptionContainer = document.querySelector('.process-description#task-list-description') || 
                                          document.querySelector('.process-description') ||
                                          document.querySelector('.task_list_process_description .process-description');
      
      if (data.task_list_description) {
        
        if (taskListDescriptionContainer) {
          var descriptionTmp = document.createElement('div');
          descriptionTmp.innerHTML = data.task_list_description;
          var newContent = descriptionTmp.querySelector('.process-description') || 
                          descriptionTmp.querySelector('.task_list_process_description') ||
                          descriptionTmp.firstElementChild;
          
          if (newContent) {
            
            if (taskListDescriptionContainer.parentElement && 
                taskListDescriptionContainer.parentElement.classList.contains('task_list_process_description')) {
              taskListDescriptionContainer.parentElement.outerHTML = newContent.outerHTML;
            } else {
              taskListDescriptionContainer.outerHTML = newContent.outerHTML;
            }
          }
        } else {
          
          var taskListWrapper = document.querySelector(`.process#task_list_${taskListId}`);
          if (taskListWrapper && data.task_list_description) {
            var descriptionTmp = document.createElement('div');
            descriptionTmp.innerHTML = data.task_list_description;
            var newDescription = descriptionTmp.querySelector('.task_list_process_description') || 
                                descriptionTmp.firstElementChild;
            if (newDescription) {
              taskListWrapper.insertAdjacentElement('beforebegin', newDescription);
            }
          }
        }
      } else {
        
        if (taskListDescriptionContainer) {
          var taskListProcessDescription = taskListDescriptionContainer.closest('.task_list_process_description');
          if (taskListProcessDescription) {
            taskListProcessDescription.remove();
          } else {
            taskListDescriptionContainer.remove();
          }
        }
      }
      
      
      if (data.task_list_settings) {
        
        var taskListSettings = document.querySelector('.page-actions .task-list-settings') ||
                              document.querySelector('.task-list-settings');
        
        if (taskListSettings) {
          var settingsTmp = document.createElement('div');
          settingsTmp.innerHTML = data.task_list_settings;
          var newSettings = settingsTmp.querySelector('.task-list-settings') || settingsTmp.firstElementChild;
          
          if (newSettings) {
            
            var wasOpen = taskListSettings.classList.contains('open');
            var dropdownContent = taskListSettings.querySelector('.dropdown-content');
            var wasDropdownOpen = dropdownContent && !dropdownContent.classList.contains('hidden');
            
           
            taskListSettings.outerHTML = newSettings.outerHTML;
            
            
            var updatedSettings = document.querySelector('.page-actions .task-list-settings') ||
                                 document.querySelector('.task-list-settings');
            
            if (updatedSettings) {
              
              if (wasOpen) {
                updatedSettings.classList.add('open');
              }
              
              var updatedDropdownContent = updatedSettings.querySelector('.dropdown-content');
              if (updatedDropdownContent) {
                if (wasDropdownOpen) {
                  updatedDropdownContent.classList.remove('hidden');
                }
              }
              
              
              if (window.Stimulus) {
                window.Stimulus.load(updatedSettings);
              }
            }
          }
        }
      }
      
      return;
    }
  }
});
